<div class="why-choose-positively-languages">
  <h1 class="why-choose-positively-languages__header">Why choose Kaplan?</h1>
  <div class="why-choose-positively-languages__body">
    <div class="why-choose-positively-languages__two-columns">
      <div class="why-choose-positively-languages__first-column">
        <lx-price-lists-portal-why-choose-positively-languages-reason
          reasonTitle="Over 80 years of excellence"
          reasonDescription="Kaplan has been teaching languages long enough to know what students need and the challenges a language school can face as a business. We have schools in 7 countries around the world and other divisions specializing in different areas of education."
          reasonImage="80-years.png"
        ></lx-price-lists-portal-why-choose-positively-languages-reason>
      </div>
      <div class="why-choose-positively-languages__second-column">
        <lx-price-lists-portal-why-choose-positively-languages-reason
          reasonTitle="Financial stability"
          reasonDescription="Kaplan International Languages is part of a very successful, publicly listed American company, Kaplan Inc., and is part of a large network of education and training institutions across many industries."
          reasonImage="financial-stability.png"
        ></lx-price-lists-portal-why-choose-positively-languages-reason>
      </div>
    </div>
    <div class="why-choose-positively-languages__two-columns">
      <div class="why-choose-positively-languages__first-column">
        <lx-price-lists-portal-why-choose-positively-languages-reason
          reasonTitle="High ethical standards"
          reasonDescription="Corporate social responsibility is one of Kaplan International Languages’ main focuses. Kaplan does what it can to support the communities in which we operate, ensuring everything we do has the best interests of others at heart. We are careful to follow all commercial rules in the countries where our schools are located and have no complaints listed in local industry organizations made against us."
          reasonImage="ethical-standards.png"
        ></lx-price-lists-portal-why-choose-positively-languages-reason>
      </div>
      <div class="why-choose-positively-languages__second-column">
        <lx-price-lists-portal-why-choose-positively-languages-reason
          reasonTitle="No 'Too-Good-To-Be-True' promotions"
          reasonDescription="Large discounts ultimately compromise the quality of the education you are receiving. Kaplan always ensures that your experience will be of the highest standard. We only ever offer promotions to add value to your booking - this will never result in us cutting corners or including hidden costs that normally follow such business practices."
          reasonImage="promotions.png"
        ></lx-price-lists-portal-why-choose-positively-languages-reason>
      </div>
    </div>
    <div class="why-choose-positively-languages__two-columns">
      <div class="why-choose-positively-languages__first-column">
        <lx-price-lists-portal-why-choose-positively-languages-reason
          reasonTitle="Guaranteed progress"
          reasonDescription="On selected Intensive English courses in most countries, we can guarantee that you will improve by at least one level of proficiency mapped to the Common European Framework of Reference (CEFR) every 10 weeks. Unlike many language schools, our proficiency levels don’t give you a false sense of progress - by the end of your course, you will see significant improvement. Always check what a “level” really means in a school, and if it’s backed up by research."
          reasonImage="guaranteed-progress.png"
        ></lx-price-lists-portal-why-choose-positively-languages-reason>
      </div>
      <div class="why-choose-positively-languages__second-column">
        <lx-price-lists-portal-why-choose-positively-languages-reason
          reasonTitle="A large network of partner universities and institutions"
          reasonDescription="Kaplan has specialized divisions for various professions and strong working partnerships with some of the best universities in the US, UK and Australia, helping you to pursue your higher education goals."
          reasonImage="network-partners.png"
        ></lx-price-lists-portal-why-choose-positively-languages-reason>
      </div>
    </div>
    <div class="why-choose-positively-languages__two-columns">
      <div class="why-choose-positively-languages__first-column">
        <lx-price-lists-portal-why-choose-positively-languages-reason
          reasonTitle="Highly rated on Trustpilot"
          reasonDescription="Kaplan International Languages has an 'Excellent' Trustpilot rating, based on reviews from our former students."
          reasonImage="trustpilot.png"
        ></lx-price-lists-portal-why-choose-positively-languages-reason>
      </div>
      <div class="why-choose-positively-languages__second-column">
        <lx-price-lists-portal-why-choose-positively-languages-reason
          reasonTitle="Fully accredited"
          reasonDescription="Kaplan International Languages is fully accredited in all the markets in which we trade. We take the advice of regulatory bodies very seriously to ensure that the product we offer is the best it can be for language students."
          reasonImage="accredited.png"
        ></lx-price-lists-portal-why-choose-positively-languages-reason>
      </div>
    </div>
  </div>
</div>
